import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import { Provider } from "react-redux";
import store from "../src/Store/store";
import { BrowserRouter as Router } from "react-router-dom"; // Import your Redux store
import { ChatProvider } from "./Services/ChatService";
import { OtpProvider } from "./Contexts/OtpContext";
import setupAxiosInterceptors from "./Store/axiosConfig";
import { isSupported } from "firebase/messaging";
// Must stay LAST among CSS imports: this layer has to outrank index.css,
// App.css and bootstrap.
import "./theme-minimal.css";

// Put any other imports below so that CSS from your
// components takes precedence over default styles.

const root = ReactDOM.createRoot(document.getElementById("root"));
const loader = document.getElementById("loader");
if (loader) {
  setTimeout(() => {
    loader.style.display = "none";
  }, 2000); // Hide loader after 2 seconds
}
setupAxiosInterceptors();

if ("serviceWorker" in navigator) {
  isSupported().then((supported) => {
    if (supported) {
      // init messaging
      navigator.serviceWorker
        .register(`/firebase-messaging-sw.js`)
        .then((registration) => {
          console.log("Service Worker registered: ", registration);
        })
        .catch((err) => {
          console.log("Service Worker registration failed: ", err);
        });
    } else {
      console.log("Firebase Messaging not supported on this browser");
    }
  });
}

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Router>
      <ChatProvider>
        <OtpProvider>
          <App />
        </OtpProvider>
      </ChatProvider>
    </Router>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
